export default {
  PASSENGER_CHANGE_ASSIGN: 'passenger-change-assign',
};
